module.exports = __webpack_public_path__ + "static/media/todolist1.2fd706ac.png";